<div [ngClass]="{'formula-panel':!small, 'formula-panel-small':small}" >
    <div [ngClass]="{'formula-left-panel':!small, 'formula-left-panel-small':small}"  >
        <div class="search-panel">
            <div class="filterclass2">
                <div class="tem-field">
                    <nz-input-group [nzSuffix]="searchSuffix">
                        <input nz-input (keyup)="updateFilter($event)"
                               [placeholder]="'formulatester.filterplaceholder'|translateTA">
                    </nz-input-group>
                    <ng-template #searchSuffix>
                        <span nz-icon nzType="search" class="field-action"></span>
                    </ng-template>
                </div>
            </div>
            <div class="list-formula">
                <div class="list-subheader">{{'formulatester.functions'|translateTA}}</div>
                <div class="list-item" *ngFor="let item of formulaListTemp"
                     [class.selected]="item === selectedItem"
                     (click)="showDesc=true;selectedItem=item"
                     draggable="true"
                     (dragstart)="dragstart_handler($event)"
                     [attr.data-drag-data]="item|json">
                    <div class="list-formula-item">
                        <div class="list-icon"><span nz-icon nzType="thunderbolt"></span></div>
                        <div class="item-line" nz-tooltip [nzTooltipTitle]="item.name + ' - ' + item.description">{{item.name}} - {{item.description}}</div>
                    </div>
                </div>
                <nz-empty *ngIf="formulaListTemp.length === 0" nzNotFoundImage="simple"
                          [nzNotFoundContent]="'formulatester.noformulas'|translateTA"></nz-empty>
            </div>
        </div>
        <nz-divider *ngIf="showDesc" class="panel-divider"></nz-divider>
        <div [ngClass]="{'box-description':!small, 'box-description-small':small}"  *ngIf="showDesc">

            <div class="box-description-detail">
                <div class="box-description-detail-title">{{'formulatester.description'|translateTA}}</div>
                <div class="box-description-detail-info">
                    {{selectedItem.description}}
                </div>
                <ng-container  *ngIf="selectedItem.sintaxe" >
                    <nz-divider class="panel-divider"></nz-divider>
                    <div class="box-description-detail-title">{{'formulatester.expression'|translateTA}}</div>
                    <div class="box-description-detail-info sintaxe"
                    draggable="true"
                    (dragstart)="dragstart_handler2($event)"
                    [attr.data-drag-data]="selectedItem.sintaxe|json">
                        {{selectedItem.sintaxe.expression}}({{selectedItem.sintaxe.parameters}})
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
    <div [ngClass]="{'v-divider': vertical, 'h-divider': !vertical}"></div>
    <div [ngClass]="{'formula-right-panel':!small, 'formula-right-panel-small':small}">
        <div class="formula-context">
            <div class="boxtext">
                <div class="tem-field formula-field">
                    <div class="tem-field-label-row">
                        <span class="tem-field-label">{{'formulatester.formula'|translateTA}} <span class="tem-field-required">*</span></span>
                        <span class="tem-field-suffix">
                            <button nz-button type="button" nzType="text" nzShape="circle" nzSize="small" tabindex="-1"
                                    nz-tooltip [nzTooltipTitle]="'formulatester.execute'|translateTA"
                                    (click)="executeFormula()">
                                <span nz-icon nzType="thunderbolt"></span>
                            </button>
                        </span>
                    </div>
                    <textarea nz-input class="formula-textarea" [(ngModel)]="formula"
                              [ngModelOptions]="{standalone:true}"
                              [placeholder]="'formulatester.formula'|translateTA"
                              (drop)="drop_handler($event)" (ngModelChange)="emitEvent($event)"
                              (keydown.control.enter)="executeFormula()"></textarea>
                </div>
            </div>
            <nz-divider class="panel-divider"></nz-divider>
            <div class="box-description-result">
                <div class="box-description-detail">
                    <div class="result-formula">
                        {{resultado || ('formulatester.noresult'|translateTA)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
